export default "__VITE_ASSET__D6FI5c5l__"